import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './WeekSelectorPEP.html?raw';
import "../../../moreCore/UI/SelectBox/SelectBox";


import "../../../moreCore/UI/RadioGroup/RadioGroup";
import RadioGroup from '../../../moreCore/UI/RadioGroup/RadioGroup';
import { DateHelpers, ToasterHelpers, TranslationHelpers } from "../../../more/Helpers";
import Multiselect from '../../../moreCore/UI/Multiselect/Multiselect';
import "../../../moreCore/UI/Multiselect/Multiselect";
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
import "../../../moreCore/UI/SearchSelect/SearchSelect";



interface Entity_Calendarweek {
    ID: string;
    Classname: string;
    calendarweek_txt_short: string;
    calendarweek_txt_long: string;
    calendarweek_int: number;
    ref_sys_year: {
        year_txt: string;
    }
    ref_sys_day_start: {
        day_date: string
    }
    ref_sys_day_end: {
        day_date: string
    }
}

interface Entity_Year {
    ID: string;
    Classname: string;
    year_txt: string;
    year: number
}

interface Entity_Month {
    ID: string;
    month_int: number;
    month_txt: string;
    month_date: number
}

interface RgbColor {
    Hex: string;
    IsNull: boolean;
    Red: number;
    Green: number;
    Blue: number;
}

interface PitColor {
    BackColor: RgbColor;
    TextColor: RgbColor;
}

interface Entity_FunctionalGroup {
    ID: string;
    code: string;
    description: string;
    order: number;
    coloration?: PitColor;
}
class WeekSelectorPEP extends compose(_WidgetBaseSP) {
    templateString: any = template;

    SelectBox_year: MdsLax<InstanceType<typeof SearchSelect>>;
    SelectBox_week: MdsLax<InstanceType<typeof Multiselect>>;
    SelectBox_month: MdsLax<InstanceType<typeof SearchSelect>>;
    SelectBox_functionalGroups: MdsLax<InstanceType<typeof Multiselect>>;
    RadioGroup_timeFilterMode: MdsLax<InstanceType<typeof RadioGroup>>;
    private years: Array<Entity_Year>;
    private functionalGroups: Array<Entity_FunctionalGroup>;
    directBookingId: string;
    directProjectId: string;
    private timeBasedFilterContainer: HTMLDivElement;
    private sectionMonth: HTMLDivElement;
    private sectionWeeks: HTMLDivElement;
    private sectionFunctionGroups: HTMLDivElement;
    private sectionYear: HTMLDivElement;

    constructor(directBookingId?: string, directProjectId?: string) {
        super(...(arguments as unknown as []));
        this.directBookingId = directBookingId;
        this.directProjectId = directProjectId;
    }

    private _onChange_Year() {
        let yearId = this.SelectBox_year.getValue();
        localStorage.setItem("PEPmatrix_lastselected__year", yearId);

        if (yearId) {
        this.loadWeeks();
        this.loadMonths();}
    }

    private _onChange_Week() {
        let values = this.SelectBox_week.getValue();
        if (values?.length) localStorage.setItem("PEPmatrix_lastselected__week", values.join(","));
        this._checkValid();
    }

    private _onChange_RadioGroup_timeFilterMode(): void {
        //this.RadioGroup_timeFilterMode.setAlignment("horizontal");
        let filterMode: string = this.RadioGroup_timeFilterMode.getValue() as string;
        //console.log(filterMode);

        this.hideNode(this.sectionWeeks, filterMode != "weeks");
        this.hideNode(this.sectionMonth, filterMode != "month");
        
        this._checkValid();
    }

    // #region Weeks
    private loadWeeks(): void {
        this.StandbyStart();

        let year: string = null;
        let yearId: string = this.SelectBox_year.getValue();
        if (yearId != null && this.years != null) {
            for (var yearEntity of this.years) {
                if (yearEntity.ID == yearId) {
                    year = yearEntity.year_txt;
                }
            }

            this.RequestManager.callfunction(
                "Webtool_API_PepMatrix__GetData_Calendarweeks",
                { "year": year },
                lang.hitch(this, this.loadWeeks_Response),
                lang.hitch(this, this.loadWeeks_Error)
            );
        }
    }
    
    private loadWeeks_Response(calendarweeks: Array<Entity_Calendarweek>): void {
        this.StandbyStop();
        console.log("loadWeeks_Response", calendarweeks);
        this._renderWeeks(calendarweeks);
    }

    private loadWeeks_Error(error): void {
        this.StandbyStop();
        ToasterHelpers.showToast({
            title: "error loading weeks",
            message: error.Message,
            iconClass: toasterIcons.error
        });
    }

    private _renderWeeks(calendarweeks: Array<Entity_Calendarweek>): void {
        let weekSelectParent: Node = this.sectionWeeks;

        this.SelectBox_week = new Multiselect();
        this.SelectBox_week.setLabel("OM_Matrix__lbl_Week");
        //this.SelectBox_week.setBlankOption("XXX", this.getTranslation("OM_Matrix__lbl_SelectWeek"));
        //this.SelectBox_week.setMultiselectHeight(8);
        this.SelectBox_week.minCount = 1;
        this.SelectBox_week.maxCount = 8;
        //this.SelectBox_week.setMultiselect(true);
        this.SelectBox_week.setMandatory(true);
        this.SelectBox_week.placeAt(weekSelectParent, "only");
        this.SelectBox_week.on("change", lang.hitch(this, this._onChange_Week));

        let currentWeekNumber = this.getWeekNumber(new Date());
        let currentWeekID = null;


        let labels: string[] = [];
        let values: string[] = [];
        let colorsBG: string[] = [];
        for (let weekEntity of calendarweeks) {
            if (weekEntity.calendarweek_int > 0) {
                let label = weekEntity.calendarweek_txt_short + " (" + DateHelpers.dateToString(new Date(weekEntity.ref_sys_day_start.day_date)) + " - " + DateHelpers.dateToString(new Date(weekEntity.ref_sys_day_end.day_date)) + ")";
                let color = "";
                if (weekEntity.calendarweek_int == currentWeekNumber && weekEntity.ref_sys_year.year_txt == new Date().getFullYear().toString()) {
                    currentWeekID = weekEntity.ID;
                    color = "var(--primary)";
                    label = TranslationHelpers.tryTranslate("OM_Matrix__lbl_CurrentWeek");// + label;
                } else {
                    
                }
                labels.push(label)
                values.push(weekEntity.ID)
                colorsBG.push(color);


                //this.SelectBox_week.addEntry(weekEntity.ID, weekEntity.calendarweek_int.toString() + " (" + weekEntity.ref_sys_day_start.day_date + " - " + weekEntity.ref_sys_day_end.day_date + ")");
            }
        }

        //this.SelectBox_week.setData(currentWeekID, calendarweeks, false, )
        this.SelectBox_week.setOptionsWithColor(values, labels, colorsBG);
        
        let lastSelected = localStorage.getItem("PEPmatrix_lastselected__week");
        if (typeof (lastSelected) != "string") {
            lastSelected = "";
        }
        let splitValues = lastSelected.split(",");
        let validValues = splitValues.filter(entry => values.indexOf(entry) != -1);
        
        if (validValues.length > 0) { // mindestens eine ID. oder mehrfach..
            //this.SelectBox_week.setMultipleValues(lastSelected.split(","));
            this.SelectBox_week.setValue(validValues);
            
        } else {
            if (currentWeekID != null) {
                this.SelectBox_week.setValue(currentWeekID);
            }
        }            
        
        this.SelectBox_week.startup();
    }
    // #endregion

    // #region years
    private loadYears(): void {
        this.StandbyStart();

        this.RequestManager.callfunction(
            "Webtool_API_PepMatrix__GetData_Years",
            {  },
            lang.hitch(this, this.loadYears_Response),
            lang.hitch(this, this.loadYears_Error)
        );
    }

    private loadYears_Response(years: Array<Entity_Year>): void {
        this.StandbyStop();
        this.years = years;
        console.log("loadYears_Response", years);
        this._renderYears(years);
    }

    private loadYears_Error(error: more.requestErrorMessage): void {
        ToasterHelpers.showToast({
            title: "error loading years",
            message: error.Message,
            iconClass: toasterIcons.error
        });
        this.StandbyStop();
    }
    private _currentYearID: string;
    private _renderYears(years: Array<Entity_Year>): void {
        let SelectParent: Node = this.sectionYear;

        this.SelectBox_year = new SearchSelect();
        this.SelectBox_year.setMandatory(true);
        this.SelectBox_year.setLabel("OM_Matrix__lbl_Year");
        this.SelectBox_year.placeAt(SelectParent, "onley");
        this.SelectBox_year.on("change", lang.hitch(this, this._onChange_Year));

        let currentYearNumber: number = new Date().getFullYear();
        let currentYearID = null;

        let labels: string[] = [];
        let values: string[] = [];
        let colorsBG: string[] = [];
        for (let yearEntity of years) {
            let color = "";
            if (yearEntity.year > 0) {
                if (yearEntity.year == currentYearNumber) {
                    currentYearID = yearEntity.ID;
                    this._currentYearID = currentYearID;
                    color = "var(--primary)";
                }

                labels.push(yearEntity.year_txt);
                values.push(yearEntity.ID);
                colorsBG.push(color);
            }
        }

        this.SelectBox_year.setOptionsWithColor(values, labels, colorsBG);

        let lastSelected = localStorage.getItem("PEPmatrix_lastselected__year");
        if (typeof (lastSelected) == "string" && lastSelected.length >= 17 && values.indexOf(lastSelected) != -1) { // mindestens eine ID. oder mehrfach..
            this.SelectBox_year.setValue(lastSelected);
        } else {
            if (currentYearID != null) {
                this.SelectBox_year.setValue(currentYearID);
            }
        }        

        this.SelectBox_year.startup();

        //this.loadWeeks(); // wochen erst laden wenn jahre da sind
        //this.loadMonths();  // monate erst laden wenn jahre da sind
    }
    // #endregion

    // #region functional groups
    private loadFunctionalGroups(): void {
        this.StandbyStart();

        this.RequestManager.callfunction(
            "Webtool_API_PepMatrix__GetData_FunctionalGroups",
            {},
            lang.hitch(this, this.loadFunctionalGroups_Response),
            lang.hitch(this, this.loadFunctionalGroups_Error)
        );
    }

    private loadFunctionalGroups_Response(functionalGroups: Array<Entity_FunctionalGroup>): void {
        this.StandbyStop();
        this.functionalGroups = functionalGroups;

        this._renderFunctionalGroups(functionalGroups);
    }

    private loadFunctionalGroups_Error(error): void {
        ToasterHelpers.showToast({
            title: "error loading functional groups",
            message: error.Message,
            iconClass: toasterIcons.error
        });

        this.StandbyStop();
    }

    private _renderFunctionalGroups(functionalGroups: Array<Entity_FunctionalGroup>): void {
        let SelectParent: Node = this.sectionFunctionGroups;

        this.SelectBox_functionalGroups = new Multiselect();
        this.SelectBox_functionalGroups.setLabel("OM_Matrix__lbl_FunctionalGroup");
        //this.SelectBox_functionalGroups.setBlankOption("XXX", this.getTranslation("OM_Matrix__lbl_SelectFunctionalGroup"));
        //this.SelectBox_functionalGroups.setMultiselectHeight(8);
        this.SelectBox_functionalGroups.setMandatory(true);
        this.SelectBox_functionalGroups.minCount = 1;
        this.SelectBox_functionalGroups.maxCount = 1;

        this.SelectBox_functionalGroups.placeAt(SelectParent, "only");
        this.SelectBox_functionalGroups.on("change", lang.hitch(this, this._onChange_FunctionalGroup));

        this.SelectBox_functionalGroups.setData(null, functionalGroups, true, "description", "ID", "coloration");            
        //for (let entity of functionalGroups) {
        //    this.SelectBox_functionalGroups.addEntry(entity.ID, entity.description, true);
        //}
        let rawValues = functionalGroups.map(entry => entry.ID);

        let lastSelectedFunctionalGroup = localStorage.getItem("PEPmatrix_lastselected__functionalGroup");
        if (typeof (lastSelectedFunctionalGroup) != "string") {
            lastSelectedFunctionalGroup = "";
        }
        let splitValues = lastSelectedFunctionalGroup.split(",");
        let validValues = splitValues.filter(entry => rawValues.indexOf(entry) != -1);
        if (validValues.length > 0) { // mindestens ein gültiger wieder gefundener Wert? vorauswählen
            this.SelectBox_functionalGroups.setValue(validValues);
        }

        //this.SelectBox_functionalGroups.startup();
    }

    private _onChange_FunctionalGroup(): void {
        //localStorage.setItem("lastselected__functionalGroup", this.SelectBox_functionalGroups.getValue());

        localStorage.setItem("PEPmatrix_lastselected__functionalGroup", this.SelectBox_functionalGroups.getValue()?.join(","));

        this._checkValid();
    }
    // #endregion

    // #region Month
    private loadMonths(): void {
        this.StandbyStart();

        let year: string = null;
        let yearId: string = this.SelectBox_year.getValue();
        if (yearId != null && this.years != null) {
            for (var yearEntity of this.years) {
                if (yearEntity.ID == yearId) {
                    year = yearEntity.year_txt;
                }
            }

            this.RequestManager.callfunction(
                "Webtool_API_PepMatrix__GetData_Months",
                { "year": year },
                lang.hitch(this, this.loadMonths_Response),
                lang.hitch(this, this.loadMonths_Error)
            );
        }
    }

    private loadMonths_Response(months: Array<Entity_Month>): void {
        this.StandbyStop();

        this._renderMonths(months);
    }

    private loadMonths_Error(error): void {
        ToasterHelpers.showToast({
            title: "error loading months",
            message: error.Message,
            iconClass: toasterIcons.error
        });

        this.StandbyStop();
    }

    private _onChange_Month(): void {
        localStorage.setItem("lastselected__month", this.SelectBox_month.getValue());

        this._checkValid();
    }

    private _renderMonths(months: Array<Entity_Month>): void {
        let monthSelectParent: Node = this.sectionMonth;

        this.SelectBox_month = new SearchSelect();
        this.SelectBox_month.setLabel(this.getTranslation("OM_Matrix__lbl_Month"));
        //this.SelectBox_month.setBlankOption("XXX", this.getTranslation("OM_Matrix__lbl_SelectMonth"));
        this.SelectBox_month.on("change", lang.hitch(this, this._onChange_Month));

        this.SelectBox_month.placeAt(monthSelectParent, "only");

        let currentmonthNumber = (new Date()).getMonth() + 1;
        let currentMonthID = null;

        let labels: string[] = [];
        let values: string[] = [];
        let colorsBG: string[] = [];
        for (let entity of months) {
            let color = "";
            if (entity.month_int > 0) {
                if (entity.month_int == currentmonthNumber) {
                    currentMonthID = entity.ID;
                    let selectedYear = this.SelectBox_year.getValue();
                    if (selectedYear == this._currentYearID && selectedYear) {
                        color = "var(--primary)";
                    }
                    
                }
                labels.push(entity.month_txt);
                values.push(entity.ID);
                colorsBG.push(color);

                //this.SelectBox_month.addEntry(entity.ID, entity.month_txt);
            }
        }

        this.SelectBox_month.setOptionsWithColor(values, labels, colorsBG);
        

        let lastSelected = localStorage.getItem("lastselected__month");
        if (typeof (lastSelected) == "string" && lastSelected.length >= 17 && values.indexOf(lastSelected) != -1) { // mindestens eine ID. oder mehrfach..
            this.SelectBox_month.setValue(lastSelected);
        } else {
            if (currentMonthID != null) {
                this.SelectBox_month.setValue(currentMonthID);
            }
        }            
        
        this.SelectBox_month.startup();
    }
    // #endregion

    private getWeekNumber(d: Date): number {
        // Copy date so don't modify original
        d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
        // Set to nearest Thursday: current date + 4 - current day number
        // Make Sunday's day number 7
        d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
        // Get first day of year
        var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
        // Calculate full weeks to nearest Thursday
        var weekNo = Math.ceil((((d.getTime() - yearStart.getTime()) / 86400000) + 1) / 7);
        // Return array of year and week number
        return weekNo;
    }

    private _handleSectionVisibility(): void {
        this.hideNode(this.timeBasedFilterContainer, !!this.directBookingId || !!this.directProjectId);
        
    }

    private _isValid: boolean = false;
    private _checkValid(): void {
        let bValid = false;
        console.trace(this.id + " _checkValid");

        if (this.SelectBox_week && this.SelectBox_month && this.SelectBox_functionalGroups && this.SelectBox_year) {
            let weeks = this.SelectBox_week.getValue();
            let month = this.SelectBox_month.getValue();
            let grps = this.SelectBox_functionalGroups.getValue();

            switch (this.RadioGroup_timeFilterMode.getValue()) {
                case "weeks":
                    bValid = weeks?.length > 0;
                    break;
                case "month":
                    bValid = !!month;
                    break;
            }

            bValid = bValid && grps?.length > 0;
        }
        if (bValid != this._isValid) {
            this.emit("valid", bValid);
            this._isValid = bValid;
        }
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.loadYears();
        this.loadFunctionalGroups();

        let directBookingId = this.getUrlParameterValue("directBookingId");
        let directProjectId = this.getUrlParameterValue("directProjectId");

        this._handleSectionVisibility();

        if (directBookingId || directProjectId) {
            this.directBookingId = directBookingId;
            this.directProjectId = directProjectId;
        }
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        //standardwert für timemode
        //
        this.RadioGroup_timeFilterMode.setValue("weeks");
        this.RadioGroup_timeFilterMode.setLabel(this.getTranslation("OM_Matrix__lbl_FilterBy"));

        this._handleSectionVisibility();
    }
}

export default mdsWidget(WeekSelectorPEP);